module.exports = __webpack_public_path__ + "img/free-trial-build-page.6ebc0e1a.png";